///
/// EarthBrowser
///
/// Created by Matt Giger on 4/8/2024
/// Copyright (c) 2024 Geodata Labs
///

import { type CameraProjection } from "@stovokor/camera/Camera"
import { matrix } from "@stovokor/math/matrix"

export class Orthographic implements CameraProjection {
	public left: number
	public right: number
	public bottom: number
	public top: number
	public near: number
	public far: number

	constructor(left: number, right: number, bottom: number, top: number, near: number, far: number) {
		this.left = left
		this.right = right
		this.bottom = bottom
		this.top = top
		this.near = near
		this.far = far
	}

	public get width(): number {
		return this.right - this.left
	}

	public get height(): number {
		return this.bottom - this.top
	}

	public setSize(width: number, height: number): void {
		this.left = 0
		this.right = width
		this.top = 0
		this.bottom = height
	}

	public get projection(): matrix {
		const rml = this.right - this.left
		const rpl = this.right + this.left
		const tmb = this.top - this.bottom
		const tpb = this.top + this.bottom
		const fmn = this.far - this.near
		const fpn = this.far + this.near

		return new matrix([
			2/rml,		0,			0,				0,
			0,			2/tmb,		0,				0,
			0,			0,			-2/fmn,			0,
			-rpl/rml,	-tpb/tmb,	-fpn/fmn,		1
		])
	}
}
